import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { useStore } from "../context/StoreContext";
import api, { formatApiError } from "../lib/api";

export default function LoginPage() {
  const { login } = useStore();
  const navigate = useNavigate();
  const [loginForm, setLoginForm] = useState({ email: "", password: "" });
  const [regForm, setRegForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const afterLogin = (data) => {
    login(data);
    toast.success(`Bem-vindo, ${data.user.name || data.user.email}`);
    navigate(data.user.role === "admin" ? "/admin" : "/conta");
  };

  const doLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const r = await api.post("/auth/login", loginForm);
      afterLogin(r.data);
    } catch (err) {
      setError(formatApiError(err, "Falha no login"));
      setLoading(false);
    }
  };

  const doRegister = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const r = await api.post("/auth/register", regForm);
      afterLogin(r.data);
    } catch (err) {
      setError(formatApiError(err, "Falha no cadastro"));
      setLoading(false);
    }
  };

  return (
    <div data-testid="login-page">
      <Header />
      <main className="max-w-md mx-auto px-6 py-20 min-h-[60vh]">
        <div className="border border-white/10 rounded-lg bg-[#111111] p-9 gold-glow">
          <h1 className="font-display text-3xl tracking-tight text-center mb-8" data-testid="login-title">Acesso</h1>
          <Tabs defaultValue="login">
            <TabsList className="w-full bg-white/5 mb-7">
              <TabsTrigger value="login" className="flex-1 data-[state=active]:bg-gold data-[state=active]:text-black" data-testid="tab-login">Entrar</TabsTrigger>
              <TabsTrigger value="register" className="flex-1 data-[state=active]:bg-gold data-[state=active]:text-black" data-testid="tab-register">Criar conta</TabsTrigger>
            </TabsList>

            {error && <p className="text-sm text-red-400 mb-5 text-center" data-testid="auth-error">{error}</p>}

            <TabsContent value="login">
              <form onSubmit={doLogin} className="space-y-5" data-testid="login-form">
                <div>
                  <Label htmlFor="li-email">E-mail</Label>
                  <Input id="li-email" data-testid="login-email" type="email" required value={loginForm.email}
                    onChange={(e) => setLoginForm({ ...loginForm, email: e.target.value })}
                    className="mt-1.5 bg-[#141414] border-white/10 focus:border-amber-500" />
                </div>
                <div>
                  <Label htmlFor="li-pass">Senha</Label>
                  <Input id="li-pass" data-testid="login-password" type="password" required value={loginForm.password}
                    onChange={(e) => setLoginForm({ ...loginForm, password: e.target.value })}
                    className="mt-1.5 bg-[#141414] border-white/10 focus:border-amber-500" />
                </div>
                <Button type="submit" disabled={loading} data-testid="login-submit-button"
                  className="w-full bg-gold text-black hover:bg-gold-light font-semibold h-11 transition-colors">
                  {loading ? "Entrando..." : "Entrar"}
                </Button>
              </form>
            </TabsContent>

            <TabsContent value="register">
              <form onSubmit={doRegister} className="space-y-5" data-testid="register-form">
                <div>
                  <Label htmlFor="rg-name">Nome completo</Label>
                  <Input id="rg-name" data-testid="register-name" required value={regForm.name}
                    onChange={(e) => setRegForm({ ...regForm, name: e.target.value })}
                    className="mt-1.5 bg-[#141414] border-white/10 focus:border-amber-500" />
                </div>
                <div>
                  <Label htmlFor="rg-email">E-mail</Label>
                  <Input id="rg-email" data-testid="register-email" type="email" required value={regForm.email}
                    onChange={(e) => setRegForm({ ...regForm, email: e.target.value })}
                    className="mt-1.5 bg-[#141414] border-white/10 focus:border-amber-500" />
                </div>
                <div>
                  <Label htmlFor="rg-pass">Senha (mín. 6)</Label>
                  <Input id="rg-pass" data-testid="register-password" type="password" required minLength={6} value={regForm.password}
                    onChange={(e) => setRegForm({ ...regForm, password: e.target.value })}
                    className="mt-1.5 bg-[#141414] border-white/10 focus:border-amber-500" />
                </div>
                <Button type="submit" disabled={loading} data-testid="register-submit-button"
                  className="w-full bg-gold text-black hover:bg-gold-light font-semibold h-11 transition-colors">
                  {loading ? "Criando..." : "Criar conta"}
                </Button>
              </form>
            </TabsContent>
          </Tabs>

          <p className="text-xs text-zinc-600 text-center mt-7">
            Você também pode <Link to="/checkout" className="text-gold hover:underline">comprar como convidado</Link>, sem criar conta.
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
